import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import styles from '../styles/frame/frame.module.scss';
import Main from './main';
import StakeSettings from './stake/stake-settings';
import StakeDetails from './stake/stake-details';
import StakeConfirm from './stake/stake-confirm';
import StakeSuccess from './stake/stake-success';
import UnstakeSettings from './unstake/unstake-settings';
import UnstakeInformation from './unstake/unstake-information';
import UnstakeDetails from './unstake/unstake-details';
import UnstakeImmediatelyDetails from './unstake/unstake-immediately-details';
import UnstakeConfirm from './unstake/unstake-confirm';
import UnstakeSuccess from './unstake/unstake-success';
import WithdrawDetails from './withdraw/withdraw-details';
import WithdrawConfirm from './withdraw/withdraw-confirm';
import WithdrawSuccess from './withdraw/withdraw-success';
import Error from './error';
import { useGetTheme } from '../../../../../hooks/useGetTheme';

const OmV3Frame = () => {
  const dark = useSelector((state) => state.basic.dark);
  const colors = useGetTheme();

  const { status, stakeBalance, unstakedBalance } = useSelector((state) => state.OMV3stake.stake);

  return (
    <div
      className={cn(styles.cardContainer, { [styles.dark]: dark })}
      style={{ color: colors.text, backgroundColor: colors.stakingFrameBackground }}
    >
      {[stakeBalance, unstakedBalance].some((value) => value !== '0') && status === 0 ? (
        <Main />
      ) : null}
      {[stakeBalance, unstakedBalance].every((value) => value === '0' && status === 0) ||
      status === 1 ? (
        <StakeSettings />
      ) : null}
      {status === 2 ? <StakeDetails /> : null}
      {status === 3 ? <StakeConfirm /> : null}
      {status === 4 ? <StakeSuccess /> : null}

      {status === 20 ? <UnstakeSettings /> : null}
      {status === 21 ? <UnstakeInformation /> : null}
      {status === 25 ? <UnstakeImmediatelyDetails /> : null}
      {status === 22 ? <UnstakeDetails /> : null}
      {status === 23 ? <UnstakeConfirm /> : null}
      {status === 24 ? <UnstakeSuccess /> : null}

      {status === 40 ? <WithdrawDetails /> : null}
      {status === 41 ? <WithdrawConfirm /> : null}
      {status === 42 ? <WithdrawSuccess /> : null}

      {status === 99 ? <Error /> : null}

      {/* {status === 100 ? <History /> : null} */}
    </div>
  );
};

export default OmV3Frame;
